import { render } from "./Donations.vue?vue&type=template&id=5503607f&scoped=true"
import script from "./Donations.vue?vue&type=script&lang=js"
export * from "./Donations.vue?vue&type=script&lang=js"

import "./Donations.vue?vue&type=style&index=0&id=5503607f&scoped=true&lang=css"

import exportComponent from "/Users/ran/Development/temp/invitee-manager/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5503607f"]])

export default __exports__